import React from 'react';
import {Helmet} from "react-helmet-async";
import hero_img from '../img/hero_img.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import AdvantagesAdmin from '../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../auxiliary-components/shared/TextAboveFooterNew";
import { UkrainiansTogetherCardTerms, wogUkrainiansTogetherLink } from '../../../services/urls/urls';
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import { Preloader } from 'MWComponents';
import "../less/ut-card.less";
import CardOrderModal from '../../../auxiliary-components/CardOrderModal';
import wog_logo from '../img/wog_logo.svg';
import epicentr_logo from '../img/epicentr_logo.svg';
import foxtrot_logo from '../img/foxtrot_logo.svg';
import InfoBlock from '../../../auxiliary-components/shared/InfoBlock';
import socialProgramItems from '../enums/social_program_items.json';
import additional_items from '../enums/additional_items.json';
import tariffs_data from '../enums/tariffs_data.json';
import hero_data from '../enums/hero_data.json';
import DOMPurify from 'utils/sanitize';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';

export default function template() {
  const page = 'ut-card-new';
  const model = this.getModel();

  const metaData = [
      {"name": "title", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
      {"name": "description", "content": "Знижки до 50% \uD83D\uDCB8 Кешбек до 20% на покупки \uD83C\uDF81 Кредитний ліміт від 0 до 200 000 ₴ \uD83D\uDCB3 Пільговий період до 62 днів \uD83D\uDCC6 Надання безоплатної вторинної правової допомоги \uD83C\uDD98"},
      {"property": "og:title", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
      {"property": "og:site_name", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
      {"property": "og:url", "content": "https://a-bank.com.ua/cards/ukrainians_together"},
      {"property": "og:image", "content": "https://drive.google.com/file/d/15Y8-i4YYkdomf_uZNFuz5IE5QhHDFq9o/view?usp=sharing"},
      {"property": "og:description", "content": "Знижки до 50% \uD83D\uDCB8 Кешбек до 20% на покупки \uD83C\uDF81 Кредитний ліміт від 0 до 200 000 ₴ \uD83D\uDCB3 Пільговий період до 62 днів \uD83D\uDCC6 Надання безоплатної вторинної правової допомоги \uD83C\uDD98"},
  ];

  const tabs = [{tab: 'tariffs', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_TITLE_01'},
        {tab: 'calculator', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_TITLE_02'},
        {tab: 'social-program', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_TITLE_03'},
        {tab: 'get-card', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_TITLE_04'}];

  const tabsPartners = [{tab: 'wog', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_PARTNERS_TITLE_01'},
        {tab: 'epicentr', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_PARTNERS_TITLE_02'},
        {tab: 'foxtrot', title: 'UKRAINIANS_TOGETHER_CARD_NEW_TABS_PARTNERS_TITLE_03'}];

  const handlersMap = {
    scrollToFaq: this.scrollToFrequentlyAskedQuestions,
    toggleHeroModal: this.toggleModal,
  };

  const imagesMap = {
    additional_product_img_1,
    additional_product_img_2,
  };

  const additionalCards = additional_items.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const tariffsData = tariffs_data.map(item => {
    if (typeof item.label === 'object' && item.label.link.onClick) {
      return {
        ...item,
        label: {
          ...item.label,
          link: {
            ...item.label.link,
            onClick: handlersMap[item.label.link.onClick],
          },
        },
      };
    }

    return item;
  });

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      onClick: handlersMap[hero_data.link.onClick],
    },
  };

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <>
      <Helmet meta={metaData}>
        <title>{'Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»'}</title>
      </Helmet>
      <div className="ut-card-new">
        <Hero
          data={heroData}
          img={hero_img}
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <AdvantagesAdmin
                data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
                loader={this.state.loader}
              />
              <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
                <Tariffs
                  items={tariffsData}
                  title={'UKRAINIANS_TOGETHER_CARD_NEW_CARDS_TARIFFS_TITLE'}
                  btnLink={UkrainiansTogetherCardTerms}
                  btnText={'UKRAINIANS_TOGETHER_CARD_NEW_CARDS_TARIFFS_BTN'}
                  page={page}
                />
                {model.creditSum ? (
                  <CalculatorNew model={model} type="credit_cards" {...this.props}/>
                ) : <Preloader />}
                <div className="social-program">
                  <div className="container">
                    <div className="social-program__body">
                      {socialProgramItems.map((item, index) => (
                        <div
                          key={index}
                          className={`social-program__item item-social-program item-social-program_${index + 1}`}
                        >
                          <h3 className="item-social-program__title">{this.l10n(item.title)}</h3>
                          <div className="item-social-program__text">{this.l10n(item.text)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <InfoBlock 
                  text={'UKRAINIANS_TOGETHER_CARD_NEW_INFO_TEXT'}
                  btnLink="https://www.ukrazom.org/contacts-card"
                  btnText={'UKRAINIANS_TOGETHER_CARD_NEW_INFO_BTN'}
                />   
              </Tabs>
              <Tabs tabs={tabsPartners} toggle={this.togglePartnersTab} tab={this.state.tabPartners} title={'UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_TABS_TITLE'} page={page}>
                <div className="partners-discounts">
                  <div className="container">
                    <div className="partners-discounts__body">
                      <img className="partners-discounts__image" src={wog_logo} alt="wog image" />
                      <div className="partners-discounts__text text-partners-discounts">
                        <div className="text-partners-discounts__block">
                          <h3 className="text-partners-discounts__title">{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_01")}</h3>
                          <p>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_02")}</p>
                        </div>
                        <div className="text-partners-discounts__block">
                          <p>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_03")}</p>
                          <ul>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_04")}</li>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_05")}</li>
                          </ul>
                        </div>
                        <div className="text-partners-discounts__block">
                          <p>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_06")}</p>
                          <ul>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_07")}</li>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_08")}</li>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_09")}</li>
                          </ul>
                        </div>
                        <div className="text-partners-discounts__block" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_TEXT_10'))}}></div>
                      </div>
                      <a href={wogUkrainiansTogetherLink} target="_blank" className="partners-discounts__btn" id={`${page} wog-details-btn`}>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_01_BTN")}</a>
                    </div>
                  </div>
                </div>
                <div className="partners-discounts">
                  <div className="container">
                    <div className="partners-discounts__body">
                      <img className="partners-discounts__image" src={epicentr_logo} alt="epicentr image" />
                      <div className="partners-discounts__text text-partners-discounts">
                        <div className="text-partners-discounts__block">
                          <h3 className="text-partners-discounts__title">{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_TEXT_01")}</h3>
                        </div>
                        <div className="text-partners-discounts__block">
                          {this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_TEXT_02")}
                        </div>
                        <div className="text-partners-discounts__block">
                          {this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_TEXT_03")}
                        </div>
                        <div className="text-partners-discounts__block text-partners-discounts__block_special">
                          {this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_TEXT_04")}
                        </div>
                        <div className="text-partners-discounts__block" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_TEXT_05'))}}></div>
                      </div>
                      <a href="https://epicentrk.ua/" target="_blank" className="partners-discounts__btn" id={`${page} epicentr-details-btn`}>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_02_BTN")}</a>
                    </div>
                  </div>
                </div>
                <div className="partners-discounts">
                  <div className="container">
                    <div className="partners-discounts__body">
                      <img className="partners-discounts__image" src={foxtrot_logo} alt="foxtrot image" />
                      <div className="partners-discounts__text text-partners-discounts">
                        <div className="text-partners-discounts__block">
                          <h3 className="text-partners-discounts__title">{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_01")}</h3>
                          <p>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_02")}</p>
                        </div>
                        <div className="text-partners-discounts__block">
                          <ul>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_03")}</li>
                            <li>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_04")}</li>
                          </ul>
                        </div>
                        <div className="text-partners-discounts__block text-partners-discounts__block_special">
                          {this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_05")}
                        </div>
                        <div className="text-partners-discounts__block" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_TEXT_06'))}}></div>
                      </div>
                      <a href="https://foxtrot.com.ua/" target="_blank" className="partners-discounts__btn" id={`${page} foxtrot-details-btn`}>{this.l10n("UKRAINIANS_TOGETHER_CARD_NEW_PARTNERS_DISCOUNTS_03_BTN")}</a>
                    </div>
                  </div>
                </div>
              </Tabs>
              <AdditionalProduct
                items={additionalCards}
                title={'UKRAINIANS_TOGETHER_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                page={page}
              />
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'UKRAINIANS_TOGETHER_CARD_NEW_FAQ_STORYBOOK_TITLE'}
                page={page}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
              <TextAboveFooterNew
                widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('UKRAINIANS_TOGETHER_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('UKRAINIANS_TOGETHER_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
        {this.state.showModal ? 
          <CardOrderModal closeModal={this.toggleModal} product={"ukrainians_together"} isOpen={this.state.showModal} /> : ''
        }
      </div>
    </>
  );
}
